var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.43 14.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1{stroke:#cd1719;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.5px;}.cls-2{fill:#cd1719;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.18,14a.65.65,0,0,1-.65.65H9.36A.65.65,0,0,1,8.71,14V8.86a.65.65,0,0,1,.65-.65h5.17a.65.65,0,0,1,.65.65ZM6.72,14a.65.65,0,0,1-.65.65H.9A.65.65,0,0,1,.25,14V8.86A.65.65,0,0,1,.9,8.21H6.07a.65.65,0,0,1,.65.65Zm8.46-8a.65.65,0,0,1-.65.66H9.36a.65.65,0,0,1-.65-.66V.9A.65.65,0,0,1,9.36.25h5.17a.65.65,0,0,1,.65.65Zm-8.46,0a.65.65,0,0,1-.65.66H.9a.65.65,0,0,1-.65-.66V.9A.65.65,0,0,1,.9.25H6.07A.65.65,0,0,1,6.72.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.38.83A2.55,2.55,0,1,0,5.93,3.38,2.55,2.55,0,0,0,3.38.83m0,.51a2,2,0,1,1-2,2,2,2,0,0,1,2-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.05.83A2.55,2.55,0,1,0,14.6,3.38,2.55,2.55,0,0,0,12.05.83m0,.51a2,2,0,1,1-2,2,2,2,0,0,1,2-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.38,9a2.55,2.55,0,1,0,2.55,2.55A2.55,2.55,0,0,0,3.38,9m0,.51a2,2,0,1,1-2,2,2,2,0,0,1,2-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.05,9a2.55,2.55,0,1,0,2.55,2.55A2.55,2.55,0,0,0,12.05,9m0,.51a2,2,0,1,1-2,2,2,2,0,0,1,2-2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 15.43,
    height: 14.92
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset-1.277b6cb566401d3abd2529da7fdaf11b.svg";
export { ForwardRef as ReactComponent };